import styled from 'styled-components'
import {Link, useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import http, {getDomain} from '../components/http/http'
import {getUrl} from "../components/getSubjectId";
import {ConfigText} from "../components/healthStatus/HealthStatus";
import {Title, Title3} from "./recommendations/Recommendations";
import './ThemeList.css';
import {getDefatultIndicatorValues} from "../utils/biomarkers";
import ContainerContent from './../components/ContainerContent';

const Background = styled.div``
const Block = styled.div`
  width: 100%;
  padding-top: 60px;
  padding-bottom: 60px;
  z-index: 1;
`

const Box = styled.div``

const Main = () => {
    const { t, i18n } = useTranslation()
    // const navigate = useNavigate()
    const [subjects, setSubjects] = useState<any[]>([])
    // const [values, setValues] = useState<any>(getDefatultIndicatorValues() || {})
    let values: any = {};
    try {
        let v:any = localStorage._values;
        values = JSON.parse(v) || {};
    } catch(e) {

    }

    useEffect(() => {
        http.get('/api/core/theme/subject?per_page=1002').then(subjects => {
            // console.log("subjbjjbjb", subjects)
            setSubjects(subjects)
        })
    }, [])
    values = values || {}

    let isOk = (v: any)=> {
        return /undefined|null/gi.test(v) ? '' : v;
    }
    values.gender = isOk(values.gender) ? values.gender : ''
    values.age = isOk(values.age) ? values.age : ''

    const getThemeName = (theme: any) => {
        if (!theme.name) return theme._id || ''
        
        if (typeof theme.name === 'string') {
            return theme.name
        }
        
        if (typeof theme.name === 'object' && theme.name[i18n.language]) {
            return theme.name[i18n.language]
        }
        
        return theme.name.en || theme.name.de || theme._id || ''
    }

    const sortedSubjects = [...subjects].sort((a, b) => {
        const primaryId = 1008
        if (a?._id === primaryId) return -1
        if (b?._id === primaryId) return 1
        return 0
    })

    return (
      <ContainerContent>
        <Block data-animch="0">
          <div>
            <Title3 className={'paddBs mytitle'} >
              {t('selectHealthTheme')}
            </Title3>
            <div className="themeWrap grid" data-animch={"0"}>
              {sortedSubjects.map((it, ind) => {
                const isEnabled = it._id != 1008 ? 'disabled' : '';
                let imgUrl = getImgUrl(it.files[0]);
                let _url = `/theme-info?theme=${it._id}&gender=${values?.gender || ''}&race=${values?.race || ''}&age=${values?.age || ''}`;
                return <Link to={_url} key={ind} className={`themeCard ${isEnabled}`}
                             style={{display: 'block'}}>
                  <div className="themeImg">
                    <div className="themeImgContent"
                         style={{backgroundImage: `url(${imgUrl})`}}
                    >
                    </div>
                  </div>
                  <div className="themeText">
                    {getThemeName(it)}
                  </div>
                </Link>
              })}
            </div>
          </div>
        </Block>
      </ContainerContent>
    )
}

export const getImgUrl = (file: any) => {
    return file && file.url ? getDomain() + file.url : '';
}
export default Main
